import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouterModule } from '@uirouter/angular';
import { TranslateModule } from '@ngx-translate/core';

import {
  ComponentsModule, HrefDirective
} from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';

import { ModalNotificationComponent } from './modal-notification.component';
import { ModalNotificationRoutes } from './modal-notification.routes';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    TranslateModule.forChild(),
    UIRouterModule.forChild({
      states: ModalNotificationRoutes.states
    }),
    WebbrokerCoreModule,
    HrefDirective
  ],
  declarations: [
    ModalNotificationComponent
  ]
})

export class ModalNotificationModule {
}

export {
  ModalNotificationComponent
};
